import React from "react"
import Typography from "@mui/material/Typography";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import {SosTextfragmentType} from "../../types";

export interface Props {
    sosTextFragment: SosTextfragmentType,
    dataCypress?: string
}

function C029TextFragment(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const fragmentTxt = getTextFragment(props.sosTextFragment);
    return (
        <CCOContainer id={props.sosTextFragment.id} dataCypress={props.dataCypress}>
            {props.sosTextFragment.title ?
                <Typography
                    variant="h3"
                    {...metaDataProperty(isPreview,
                                                                                   'properties.title',
                                                                                   props.sosTextFragment.id)}
                    sx={{
                        marginBottom: 2
                    }}>
                    {props.sosTextFragment.title}
                </Typography> : <></>}

            {fragmentTxt ?
                <CCORichText metadataId={props.sosTextFragment.id}
                             textAsTree={fragmentTxt.textAsTree}
                             propertyName='properties.detailText'/>
                : <></>}
        </CCOContainer>
    );
}

function getTextFragment(textFragment: SosTextfragmentType) {
    if (textFragment.detailText && textFragment.detailText.textAsTree) {
        return textFragment.detailText;
    } else {
        return textFragment.teaserText
    }
}

export default C029TextFragment;